import React from 'react';
import cn from 'classnames';

import css from './DrawerCloseBtn.module.scss';

interface Props {
  onClick?: () => void;
  className?: string;
}

export const DrawerCloseBtn: React.FC<Props> = (props) => {
  const { onClick = undefined, className = '' } = props;

  return <div className={cn(css.closeBtn, className)} onClick={onClick} />;
};
